import React from "react";
import "./ConnDevices.css";
import { VscDebugDisconnect } from "react-icons/vsc";
const ConnDevices = ({
  devices_list,
  connectorsList,
  adapters_list,
  connector,
  orientation,
}) => {
  const getConnectedDevicesForConnector = (connector) => {
    const devices_id = connectorsList.filter(
      (connector_item) => connector_item.id === connector.id
    )[0].connected_devices_id;
    return devices_id.map((device_id) =>
      devices_list.find((device) => device.id === device_id)
    );
  };

  const getAdapter = (adapter_id) => {
    return adapters_list.find((adapter_item) => adapter_item.id === adapter_id);
  };

  return (
    <div className="device-connected-box">
      {getConnectedDevicesForConnector(connector).length > 0 ? (
        getConnectedDevicesForConnector(connector).map((device) => (
          <>
            {orientation === "top" ? (
              <>
                <div className="device-connected-board">
                  <img
                    src={
                      `${process.env.PUBLIC_URL}/` +
                      "images/devices/" +
                      device.img_name
                    }
                  />
                </div>
                {/* <div className="vr wire-connection"></div> */}
                <div className="adapter-connected-board">
                  {getAdapter(device.adapter_id) ? (
                    <img
                      src={
                        `${process.env.PUBLIC_URL}/` +
                        "images/devices/" +
                        getAdapter(device.adapter_id).img_name
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="vr wire-connection"></div>
              </>
            ) : (
              <div>
                <div className="vr wire-connection"></div>
                <div className="adapter-connected-board">
                  {getAdapter(device.adapter_id) ? (
                    <img
                      src={
                        `${process.env.PUBLIC_URL}/` +
                        "images/devices/" +
                        getAdapter(device.adapter_id).img_name
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="vr wire-connection"></div> */}
                <div className="device-connected-board">
                  <img
                    src={
                      `${process.env.PUBLIC_URL}/` +
                      "images/devices/" +
                      device.img_name
                    }
                  />
                </div>
              </div>
            )}
          </>
        ))
      ) : (
        <>
          {orientation === "top" ? (
            <div className="no-device-connected">
              <VscDebugDisconnect
                className="device-disconnected"
                color="gray"
                size="100%"
              />
              <div className="vr wire-connection"></div>
            </div>
          ) : (
            <div className="no-device-connected">
              <div className="vr wire-connection"></div>
              <VscDebugDisconnect
                className="device-disconnected"
                color="gray"
                size="100%"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ConnDevices;
